import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { type PieceWithoutId } from '../types/Piece.js'

export type PieceSenderOrDestinationFn = (piece: PieceWithoutId) => string

export const usePieceReceiverOrSenderName = (): PieceSenderOrDestinationFn => {
  const { t } = useTranslation()

  return useCallback<PieceSenderOrDestinationFn>(
    (piece) => {
      const { receiver, sender, type: parcelType } = piece
      switch (parcelType) {
        case 'incoming':
          // TODO: This is not fully correct, but needs a change in the parcel API to be fully correct
          // TODO: See CON-9025 for more info
          if (piece.isReturn && !piece.isUndeliverable) {
            return receiver?.name ?? t('pieces.common.unknownSender')
          }
          return sender?.name ?? t('pieces.common.unknownSender')

        case 'outgoing':
          return receiver?.name ?? t('pieces.common.shipmentDetail.unknownText')
        default:
          return sender?.name ?? t('pieces.common.unknownSender')
      }
    },
    [t]
  )
}
